export type ProjectKey = string;
export type BoardId = string;
type ProjectId = string;

export const PROJECT_KEY = 'projectKey' as const;
export const BOARD_ID = 'boardId' as const;
export const PROJECT_ID = 'projectId' as const;

export type PageType = 'settings' | undefined;
export type IdentifierType = typeof PROJECT_KEY | typeof BOARD_ID | typeof PROJECT_ID | null;

export type ScopeData = {
	boardId?: BoardId;
	pageType?: PageType;
	projectId?: ProjectId;
	projectKey?: ProjectKey;
	identifierValue?: BoardId | ProjectKey | null;
	identifierType?: IdentifierType;
};
